var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKundlilogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5306 7.0936C24.9313 3.85867 31.2476 2 38 2C42.9705 2 47.7062 3.00684 52.0132 4.8293M8.24966 17.7227C4.30632 23.4986 2 30.4798 2 38C2 45.5202 4.30632 52.5014 8.24966 58.2773M19.5306 68.9064C24.9313 72.1413 31.2476 74 38 74C45.6404 74 52.7245 71.6198 58.5526 67.5606M63.4564 12.5436C69.9712 19.0583 74 28.0591 74 38C74 48.3161 69.6612 57.6182 62.7089 64.1808M15.2497 20.4317C20.5128 13.6301 28.7544 9.24346 38 9.24346C46.7139 9.24346 54.5339 13.139 59.8115 19.28M12.5103 24.6981C10.4241 28.6777 9.24346 33.2048 9.24346 38C9.24346 53.8559 22.1441 66.7565 38 66.7565C38.5969 66.7565 39.1908 66.7377 39.779 66.7015",
    stroke: "#FE607E",
    strokeWidth: 2.17304,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2784 32.7546C66.5927 34.4554 66.7579 36.2069 66.7579 37.9975C66.7579 48.1716 61.4455 57.1303 53.4488 62.2428M59.5043 37.3557C59.3971 33.7093 58.3787 30.2861 56.6663 27.3105M31.8444 17.3826C33.7958 16.7987 35.8631 16.4844 38.0014 16.4844C44.1569 16.4844 49.7169 19.0833 53.64 23.2411M16.5824 40.0227C16.5202 39.3563 16.4883 38.6798 16.4883 37.9975C16.4883 33.0487 18.1688 28.4853 20.9879 24.8448M55.751 50.141C51.8707 55.7949 45.3619 59.5105 38.0014 59.5105C31.6026 59.5105 25.8474 56.7025 21.9033 52.254M50.1515 38.1061C48.4797 36.9022 47.5439 34.9914 47.5439 33.014C47.5439 32.3229 47.6583 31.6232 47.8959 30.9438H47.867C45.0985 30.9438 42.656 29.1271 41.8607 26.476C40.7847 27.2653 39.485 27.6906 38.1506 27.69C36.7777 27.6902 35.4428 27.2398 34.3507 26.4079C33.5177 29.0098 31.0983 30.7685 28.3777 30.7685C28.3299 30.7685 28.2835 30.7685 28.2357 30.767C28.4448 31.4009 28.5514 32.064 28.5515 32.7315C28.5515 34.748 27.5766 36.6936 25.8512 37.8888C27.523 39.0927 28.4588 41.0035 28.4588 42.981C28.4588 43.672 28.3444 44.3717 28.1068 45.0511H28.1358C30.9042 45.0511 33.3467 46.8678 34.142 49.5189C36.3846 47.8761 39.4399 47.9036 41.6521 49.587C42.4851 46.9851 44.9044 45.2264 47.625 45.2264C47.6728 45.2264 47.7192 45.2264 47.767 45.2279C47.5579 44.594 47.4513 43.9309 47.4512 43.2635C47.4512 41.2469 48.4261 39.3013 50.1515 38.1061Z",
    stroke: "#FE607E",
    strokeWidth: 2.17304,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9832 39.6582C33.7648 39.1335 33.653 38.5706 33.6543 38.0023C33.6543 35.6018 35.5999 33.6562 38.0004 33.6562C40.4009 33.6562 42.3465 35.6018 42.3465 38.0023C42.3465 40.3 40.5631 42.1818 38.3046 42.3368",
    stroke: "#FE607E",
    strokeWidth: 2.17304,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8074 14.8258C14.7764 14.8258 16.3727 13.2296 16.3727 11.2605C16.3727 9.29152 14.7764 7.69531 12.8074 7.69531C10.8384 7.69531 9.24219 9.29152 9.24219 11.2605C9.24219 13.2296 10.8384 14.8258 12.8074 14.8258Z",
    stroke: "#FE607E",
    strokeWidth: 2.17304,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8074 68.3023C14.7764 68.3023 16.3727 66.7061 16.3727 64.7371C16.3727 62.7681 14.7764 61.1719 12.8074 61.1719C10.8384 61.1719 9.24219 62.7681 9.24219 64.7371C9.24219 66.7061 10.8384 68.3023 12.8074 68.3023Z",
    stroke: "#FE607E",
    strokeWidth: 2.17304,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5986 28.412C65.1987 28.412 66.4959 27.1148 66.4959 25.5146C66.4959 23.9144 65.1987 22.6172 63.5986 22.6172C61.9984 22.6172 60.7012 23.9144 60.7012 25.5146C60.7012 27.1148 61.9984 28.412 63.5986 28.412Z",
    stroke: "#FE607E",
    strokeWidth: 2.17304,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3843 46.3389C59.6645 46.3389 60.7022 45.3012 60.7022 44.021C60.7022 42.7409 59.6645 41.7031 58.3843 41.7031C57.1042 41.7031 56.0664 42.7409 56.0664 44.021C56.0664 45.3012 57.1042 46.3389 58.3843 46.3389Z",
    stroke: "#FE607E",
    strokeWidth: 2.17304,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3843 10.8702C59.6645 10.8702 60.7022 9.83243 60.7022 8.55228C60.7022 7.27214 59.6645 6.23438 58.3843 6.23438C57.1042 6.23438 56.0664 7.27214 56.0664 8.55228C56.0664 9.83243 57.1042 10.8702 58.3843 10.8702Z",
    stroke: "#FE607E",
    strokeWidth: 2.17304,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8492 22.6124C27.1293 22.6124 28.1671 21.5746 28.1671 20.2945C28.1671 19.0143 27.1293 17.9766 25.8492 17.9766C24.569 17.9766 23.5312 19.0143 23.5312 20.2945C23.5312 21.5746 24.569 22.6124 25.8492 22.6124Z",
    stroke: "#FE607E",
    strokeWidth: 2.17304,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6929 48.6593C19.9731 48.6593 21.0108 47.6215 21.0108 46.3413C21.0108 45.0612 19.9731 44.0234 18.6929 44.0234C17.4128 44.0234 16.375 45.0612 16.375 46.3413C16.375 47.6215 17.4128 48.6593 18.6929 48.6593Z",
    stroke: "#FE607E",
    strokeWidth: 2.17304,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8896 68.2166C48.4898 68.2166 49.787 66.9194 49.787 65.3193C49.787 63.7191 48.4898 62.4219 46.8896 62.4219C45.2894 62.4219 43.9922 63.7191 43.9922 65.3193C43.9922 66.9194 45.2894 68.2166 46.8896 68.2166Z",
    stroke: "#FE607E",
    strokeWidth: 2.17304,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKundlilogo);
export default __webpack_public_path__ + "static/media/kundlilogo.ef57c2c1c3db16440233c5edb4ca7e98.svg";
export { ForwardRef as ReactComponent };